import { useEffect, useState } from "react";
import BotaoContato from "../../componentes/BotaoContato/BotaoContato.js";
import "../ServicosEngAplicadaProjTec/ServicosEngAplicadaProjTec.css";
import BannerPaginaInterna from "../BannerPaginaInterna/BannerPaginaInterna.js";
import Projetos from "../Projetos/Projetos.js";
import Contato from "../Contato/Contato.js";
import Servicos from "../Servicos/Servicos.js";

function ServicosEstRegAmbiental() {
  const [openItem, setOpenItem] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal-zoom");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div>
     <BannerPaginaInterna
  tag="Estudos e Regularização Ambiental"
  titulo="Estudos e Regularização Ambiental"
  descricao="Oferecemos soluções completas em estudos ambientais e licenciamento (LP, LI e LO), garantindo conformidade com a legislação, redução de riscos e agilidade na aprovação do seu projeto junto aos órgãos ambientais."
  textoBotao="Solicitar Orçamento"
  rotaBotao="https://wa.me/5532984053160?text=Olá, quero um orçamento para regularização ambiental"
  mostrarBotaoOutline={true}
  textoBotaoOutline="Fale com Especialista"
  rotaBotaoOutline="https://wa.me/5532984053160?text=Olá, quero falar com um especialista em licenciamento ambiental"
/>

      <main className="servicos-page py-5">
        {/* HEADER */}

        {/* LISTA COM DETAILS */}
        <section className="s scroll-reveal-zoom">
          <div className="titulo-bloco">
            <h2>Nossos Serviços Especializados</h2>
            <p>
              Clique nos itens abaixo para conhecer detalhes de nossa atuação
              técnica.
            </p>
          </div>

          <p>
  A Âmbar Soluções em Engenharia e Meio Ambiente atua com <strong>estudos ambientais e regularização ambiental</strong>, oferecendo suporte completo em <strong>licenciamento ambiental, elaboração de relatórios técnicos e atendimento à legislação ambiental</strong>. Desenvolvemos soluções para empresas que precisam de <strong>segurança jurídica, agilidade na aprovação de projetos e conformidade com órgãos ambientais</strong>.
</p>

<p>
  Nossos serviços incluem <strong>licenciamento ambiental (LP, LI e LO)</strong>, <strong>dispensa de licenciamento</strong> e elaboração de <strong>estudos ambientais como EIA/RIMA, RCA e PCA</strong>. Também atuamos com <strong>regularização em APP, supressão de vegetação, projetos de intervenção ambiental (PIA)</strong> e gestão de processos junto ao <strong>IBAMA e demais órgãos ambientais</strong>.
</p>

<p className="mb-4">
  Realizamos ainda <strong>inventários florestais, recuperação ambiental (PRAD, PTRF, PRA)</strong>, <strong>outorgas de recursos hídricos</strong>, <strong>laudos técnicos e estudos de impacto ambiental</strong>, além de suporte em <strong>TACs, RPPNs e regularização fundiária (CAR)</strong>. Com <strong>alto rigor técnico, atendimento personalizado e experiência prática</strong>, garantimos eficiência, conformidade e viabilidade ambiental para o seu empreendimento.
</p>

          <div className="accordion">
            <div className="accordion">
 {/* ITEM 01 */}
<details className="item" open={openItem === 1} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 1 ? null : 1); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Licenciamento Ambiental Convencional e Simplificado</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Realizamos o <strong>gerenciamento completo de processos de licenciamento ambiental</strong>,
        tanto na modalidade convencional quanto simplificada, assegurando que seu empreendimento
        atenda integralmente às <strong>exigências legais e técnicas</strong>.
        <br />
        Atuamos em todas as etapas (<strong>LP, LI e LO</strong>), com foco na
        <strong> redução de prazos</strong>, <strong>mitigação de riscos</strong> e
        <strong> previsibilidade do processo</strong>.
        <br />
        Garantimos <strong>segurança jurídica</strong> e maior eficiência na aprovação do projeto.
      </p>

      <p className="subtitulo-descricao mt-5"><strong>Principais serviços:</strong></p>
      <ul className="lista-servico-detalhada">
        <li><strong>Licença Prévia (LP)</strong>, <strong>Licença de Instalação (LI)</strong> e <strong>Licença de Operação (LO)</strong></li>
        <li><strong>Licenciamento ambiental simplificado</strong></li>
        <li><strong>Acompanhamento técnico de processos</strong></li>
        <li><strong>Atendimento a condicionantes ambientais</strong></li>
        <li><strong>Interface com órgãos ambientais</strong></li>
      </ul>

      <BotaoContato texto="Entre em Contato" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Licenciamento Ambiental" />
    </div>
  </div>
</details>

{/* ITEM 02 */}
<details className="item" open={openItem === 2} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 2 ? null : 2); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Dispensa de Licenciamento Ambiental</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Avaliamos o <strong>enquadramento ambiental</strong> do seu empreendimento para identificar a possibilidade de
        <strong> dispensa de licenciamento</strong>, conforme a legislação vigente.
        <br />
        Reduza <strong>custos</strong>, elimine <strong>burocracias</strong> e acelere a implantação de projetos de
        <strong> baixo impacto ambiental</strong>.
        <br />
        Conduzimos todo o processo com <strong>segurança técnica e conformidade legal</strong>.
      </p>

      <p className="subtitulo-descricao mt-5"><strong>Principais serviços:</strong></p>
      <ul className="lista-servico-detalhada">
        <li><strong>Análise de enquadramento ambiental</strong></li>
        <li><strong>Solicitação de dispensa</strong></li>
        <li><strong>Documentação técnica</strong></li>
        <li><strong>Interação com órgãos ambientais</strong></li>
      </ul>

      <BotaoContato texto="Entre em Contato" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Dispensa de Licenciamento" />
    </div>
  </div>
</details>

{/* ITEM 03 */}
<details className="item" open={openItem === 3} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 3 ? null : 3); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Estudos Ambientais: EIA/RIMA, RCA e PCA</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Elaboramos <strong>estudos ambientais completos</strong> para avaliação de
        <strong> impactos</strong> e <strong>viabilidade</strong> de empreendimentos.
        <br />
        Incluímos análise dos meios <strong>físico, biótico e socioeconômico</strong>,
        com definição de <strong>medidas mitigadoras e compensatórias</strong>.
        <br />
        Garantimos <strong>rigor técnico</strong> e maior assertividade na aprovação.
      </p>

      <p className="subtitulo-descricao mt-5"><strong>Principais estudos:</strong></p>
      <ul className="lista-servico-detalhada">
        <li><strong>EIA/RIMA</strong></li>
        <li><strong>RCA</strong></li>
        <li><strong>PCA</strong></li>
      </ul>

      <BotaoContato texto="Entre em Contato" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Estudos Ambientais" />
    </div>
  </div>
</details>

{/* ITEM 04 */}
<details className="item" open={openItem === 4} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 4 ? null : 4); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Regularização em APP e Supressão de Vegetação</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Atuamos na <strong>regularização de intervenções em APP</strong> e processos de
        <strong> supressão de vegetação nativa</strong>.
        <br />
        Garantimos <strong>conformidade legal</strong>, <strong>viabilidade técnica</strong> e
        <strong> redução de riscos</strong>.
      </p>

      <BotaoContato texto="Entre em Contato" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: APP e Supressão de Vegetação" />
    </div>
  </div>
</details>

{/* ITEM 05 */}
<details className="item" open={openItem === 5} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 5 ? null : 5); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Projeto de Intervenção Ambiental (PIA)</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Desenvolvemos <strong>Projetos de Intervenção Ambiental (PIA)</strong> com foco em
        <strong> aprovação ágil</strong> e <strong>minimização de impactos</strong>.
        <br />
        Estruturamos também <strong>compensações ambientais</strong> conforme a legislação.
      </p>

      <BotaoContato texto="Entre em Contato" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: PIA" />
    </div>
  </div>
</details>

{/* ITEM 06 */}
<details className="item" open={openItem === 6} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 6 ? null : 6); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Inventários Florestais e Recuperação Ambiental</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Realizamos <strong>inventários florestais</strong> e projetos como
        <strong> PTRF, PRAD, PRADA e PRA</strong>.
        <br />
        Garantimos <strong>recuperação ambiental eficiente</strong> e
        <strong> conformidade legal</strong>.
      </p>

      <BotaoContato texto="Entre em Contato" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Inventário Florestal" />
    </div>
  </div>
</details>

{/* ITEM 07 */}
<details className="item" open={openItem === 7} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 7 ? null : 7); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Outorgas e Regularizações no IBAMA</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Conduzimos processos de <strong>outorga de uso de recursos hídricos</strong> e
        <strong> regularização ambiental</strong>.
        <br />
        Garantimos <strong>conformidade legal</strong> e segurança operacional.
      </p>

      <BotaoContato texto="Entre em Contato" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Outorgas" />
    </div>
  </div>
</details>

{/* ITEM 08 */}
<details className="item" open={openItem === 8} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 8 ? null : 8); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Laudos Técnicos e Relatórios Ambientais</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Elaboramos <strong>laudos e relatórios ambientais</strong> com alto padrão técnico,
        garantindo <strong>segurança na tomada de decisão</strong>.
      </p>

      <BotaoContato texto="Entre em Contato" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Laudos Ambientais" />
    </div>
  </div>
</details>

{/* ITEM 09 */}
<details className="item" open={openItem === 9} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 9 ? null : 9); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Estudos de Impacto e Planos Ambientais</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Desenvolvemos <strong>estudos de impacto</strong> e
        <strong> planos ambientais estratégicos</strong> para viabilização de projetos.
      </p>

      <BotaoContato texto="Entre em Contato" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Estudos de Impacto" />
    </div>
  </div>
</details>

{/* ITEM 10 */}
<details className="item" open={openItem === 10} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 10 ? null : 10); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">RPPNs, TACs e Defesa Administrativa</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Oferecemos suporte em <strong>defesas administrativas</strong>,
        <strong> TACs</strong> e criação de <strong>RPPNs</strong>.
        <br />
        Atuamos para <strong>redução de penalidades</strong> e regularização.
      </p>

      <BotaoContato texto="Entre em Contato" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Defesa Ambiental" />
    </div>
  </div>
</details>

{/* ITEM 11 */}
<details className="item" open={openItem === 11} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 11 ? null : 11); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Regularização Fundiária e CAR</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Realizamos <strong>regularização fundiária</strong> e inscrição no
        <strong> Cadastro Ambiental Rural (CAR)</strong>.
        <br />
        Garantimos <strong>segurança jurídica</strong> e valorização da propriedade.
      </p>

      <BotaoContato texto="Entre em Contato" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Regularização e CAR" />
    </div>
  </div>
</details>
              </div>  
          </div>
        </section>
      </main>
      <Projetos />
      <Servicos />
      <Contato />
    </div>
  );
}

export default ServicosEstRegAmbiental;
